import Actions, { ModuleEvents } from "./Actions";

const Handlers = {
  init: (dispatch, props) => {
    const shopId = props.shopId || props.shop?.shopId;
    if (shopId) {
      dispatch(Actions.fetchCompTypes(shopId));
    }
  },
};

export default Handlers;
